import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=1db82804&scoped=true&lang=pug&"
import script from "./PanelHeader.vue?vue&type=script&lang=js&"
export * from "./PanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=1db82804&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db82804",
  null
  
)

export default component.exports